import * as React from "react";

export function UhfIcon(props: React.SVGProps<SVGSVGElement>) {
  const color = props.color || "currentColor";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 25.135 25.135" {...props}>
      <path
        d="M11.636 19.963v-4.34L8.283 11.46C5.367 7.84 2.355 4.114.775 2.17c-.489-.601-.68-.894-.62-.953.018-.018 5.605-.026 12.415-.016l12.381.017-.831 1.069a893.81 893.81 0 01-4.14 5.211c-1.82 2.279-4.021 5.043-4.891 6.142l-1.582 2v8.663h-1.871zm-.173-8.636c.102-.635.17-2.79.171-5.42l.002-2.796-3.424.025c-3.568.026-3.792.044-3.792.309 0 .33 6.638 8.163 6.917 8.163.045 0 .102-.127.126-.28zm2.848-.17c.228-.248.944-1.083 1.59-1.855.648-.771 1.915-2.275 2.816-3.34 1.848-2.187 2.073-2.464 2.073-2.56 0-.209-.435-.239-3.859-.265l-3.424-.026.003 1.826c.004 2.193.106 6.07.17 6.42.024.138.083.25.13.25s.273-.202.5-.45z"
        fill={color}
      />
    </svg>
  );
}
